import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Building2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await login(email, password);
      toast.success('Login successful!');
      navigate('/admin');
    } catch (error) {
      toast.error('Invalid credentials. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50 px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="bg-white rounded-xl px-3 py-1.5 shadow-md border border-stone-100 inline-flex items-center justify-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_realestate-cms-15/artifacts/57kg0gau_DBK%20LOGO%20Final.png" 
                alt="DBK Group Of Companies" 
                className="h-12 w-auto"
              />
            </div>
          </div>
          <p className="text-2xl font-playfair font-bold text-stone-900 mb-2">DBK Group Of Companies</p>
          <p className="text-stone-600">Admin Panel Login</p>
        </div>

        <div className="bg-white border border-stone-200 p-8">
          <form onSubmit={handleSubmit} data-testid="login-form">
            <div className="space-y-4">
              <div>
                <Input
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  data-testid="login-email-input"
                  className="h-12 border-stone-300 focus:ring-1 focus:ring-emerald-900 focus:border-emerald-900"
                />
              </div>

              <div>
                <Input
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  data-testid="login-password-input"
                  className="h-12 border-stone-300 focus:ring-1 focus:ring-emerald-900 focus:border-emerald-900"
                />
              </div>

              <Button
                type="submit"
                disabled={loading}
                data-testid="login-submit-button"
                className="w-full bg-emerald-900 hover:bg-emerald-800 text-white px-8 py-6 uppercase tracking-widest text-xs font-bold transition-all duration-300"
              >
                {loading ? 'LOGGING IN...' : 'LOGIN'}
              </Button>
            </div>
          </form>
        </div>

        <p className="text-center text-stone-500 text-sm mt-6">
          Default credentials: admin@dbkgroup.com / admin123
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;